export default __webpack_public_path__ + "static/media/topicExchange.7d29ea64.png";